export const paperStyles = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  p: 2,
  overflow: "hidden",
  borderRadius: 0,
  backgroundColor: "backround.default",
  height: "unset",
};

export const buttonStyle = {
  mt: 2,
};

export const lottieStyle = { height: 400, width: 400 };
